<template>
  <div class="all">
    <!--    新年放假通知图片-->
    <div class="all_top_img" v-if="all.top_img">
      <img :src="$store.state.Url+all.top_img.img" alt @click="$router.push({path:'/bannerShop'})"/>
    </div>
    <Head :StatusType="StatusType"></Head>
    <!--    轮播图及内容-->
    <div class="all_chart">
      <div class="all_chart_left" v-if="all.left_img">
        <img :src="$store.state.Url+all.left_img.img" alt @click="$router.push({path:'/bannerShop'})"/>
      </div>
      <div class="all_chart_chart">
        <swiper :options="swiperOption" style="width: 100%;height: 496px;">
          <!--banner区-->
          <!-- slides -->
          <swiper-slide v-for="(item,key) in all.photo" :key="key" v-if="all">
            <img :src="$store.state.Url+item.img" alt class="lunstyle" @click="getCLick(item.url)"/>
          </swiper-slide>
          <div class="swiper-pagination swiper-pagination-red" slot="pagination"></div>
        </swiper>
        <!--        左边导航-->
        <div class="all_chart_chart_pos_nav">
          <ul>
            <li v-for="(item,key) in all.class" :key="key">
              <!--               @click="getList(item.id,item.id,item.name)"-->
              <p>{{ item.name }}</p>
              <div class="all_chart_chart_pos_nav_li_X">
                <div
                  class="all_chart_chart_pos_nav_li_X_for"
                  v-for="(cla,index) in item.class_cation"
                  :key="index"
                >
                  <div class="all_chart_chart_pos_nav_li_X_for_left" @click="getList(item.id,cla.id,cla.name)">
                    {{ cla.name }}
                  </div>
                  <div class="all_chart_chart_pos_nav_li_X_for_right">
                    <span v-for="(val,index) in cla.class_three" :key="index"
                          @click="getList1(item.id,val.id,val.name)">{{ val.name }}</span>
                    <!--        热门品牌哦-->
                    <div class="all_chart_chart_pos1">
                      <div class="all_chart_chart_pos1_top">
                        <div>
                          <img :src="$store.state.Url+good.logo" alt v-for="(good,key) in item.brand_logo"
                               @click="getPinpai(good.url)"/>
                        </div>
                        <div class="clear"></div>
                      </div>
                      <div class="all_chart_chart_pos1_cen">
                        <img :src="$store.state.Url+good.goods_img" alt v-for="(good,key) in item.goods_logo"
                             @click="getxiangqing(good.id)"/>
                      </div>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!--        广告图-->
        <div class="all_chart_chart_pos">
          <div class="all_chart_chart_pos_top">
            <div @click="$router.push('/login/')">
              <img src="../assets/wenBg.jpg" alt/>
            </div>
          </div>
          <div class="all_chart_chart_pos_cen">
            <div class="all_chart_chart_pos_cen_top">
              <span>全友动态</span>
              <p @click="$router.push({path:'/Article'})">更多 ></p>
              <div class="clear"></div>
            </div>
            <div class="all_chart_chart_pos_cen_cen">
              <!--              <p>全友积分细则</p>-->
              <ul style="height: 70px;">
                <li v-for="(item,key) in all.news" :key="key"
                    @click="$router.push({path:'/ArticleDetails',query:{id:item.id}})">
                  <span></span>
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="all_chart_chart_pos_cen_bom">
              <div class="all_chart_chart_pos_cen_bom_for" v-for="(item,key) in all.status_news" :key="key"
                   @click="$router.push({path:'/ArticleDetails',query:{id:item.id}})">
                <img :src="$store.state.Url+item.image" alt/>
                <p>{{ item.title }}</p>
              </div>
              <div class="clear"></div>
            </div>
            <div class="all_chart_chart_pos_bottom">
              <!--              all.video-->
              <video :src="$store.state.Url+all.video" width="240" height="195" controls> 

              </video>
              <!--              <img src="../assets/guanggaotu2.jpg" alt />-->
            </div>
          </div>
        </div>
      </div>
      <div class="all_chart_right" v-if="all.right_img">
        <img :src="$store.state.Url+all.right_img.img" alt @click="$router.push({path:'/bannerShop'})"/>
      </div>
      <div class="clear"></div>
    </div>
    <!--    轮播图下面广告图-->
    <div class="all_chart_img">
      <div>
        <img :src="$store.state.Url+item.img" alt @click="$router.push({path:'/bannerShop1',query:{id:item.id}})"
             v-for="(item,allkey) in all.sing" :key="allkey"/>
        <img src="../assets/ssdz.png" alt @click="$router.push({path:'/bannerShop2'})"/>
      </div>
      <div class="clear"></div>
    </div>
    <!--    全友特色购-->
    <div class="all_characteristic">
      <div class="all_characteristic_top">—— 全 办 公 场 景 ——</div>
      <div class="all_characteristic_cen">
        <swiper :options="swiperOption1" v-if="all">
          <swiper-slide v-for="(item,key) in all.fea" :key="key" v-if="item">
            <img :src="$store.state.Url+item.img" alt class="all_characteristic_cen_img"
                 @click="getjiejue(item.class_id,key)"/>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-pagination can" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <!--    分类 -->
    <div class="all_classification" id="test">
      <!--      循环-->
      <div
        class="all_classification_for"
        v-for="(item,ins) in all.one_class"
        :id="`ss${item.id}`"
        :key="ins"
        v-if="all"
      >
        <div class="all_classification_for_top">
          <div class="all_classification_for_top_left">
            <img src="../assets/louceng.png" alt/>
            <span>{{ item.name }}</span>
          </div>
          <div class="all_classification_for_top_right">
            <!--              <span class="all_classification_for_top_right_sq" @mouseenter="remen(1),item.two_class_index1 = 0" :class="remenindex == 1?'aver1':''">热门</span>-->
            <span
              v-for="(value,index) in item.two_class"
              :key="index"
              @mouseover="item.two_class_index = index,remenindex = 2"
              :class="item.two_class_index == index?'aver':''"
            >{{ value.name }}</span>
          </div>
          <div class="clear"></div>
        </div>
        <div class="all_classification_for_cen">
          <div class="all_classification_for_cen_left">
            <div class="all_classification_for_cen_left_top">
              <img :src="$store.state.Url+item.img" alt @click="getUrl(item.url)"/>
            </div>
            <div class="all_classification_for_cen_left_bottom">
              <span v-for="(value,keyTow) in item.two_class" :key="keyTow" v-if="value.name"
                    @click="getList(item.id,value.id,value.name)">{{ value.name }}</span>
            </div>
          </div>
          <!--          <div class="all_classification_for_cen_right" v-if="remenindex == 2">-->
          <div class="all_classification_for_cen_right" v-if="item.two_class_index !== 0">
            <ul>
              <!--              asdjhk -->
              <li v-for="(val,key) in item.two_class[item[`two_class_index`]].goods" :key="key"
                  @click="getxiangqing(val.id)">
                <img :src="$store.state.Url+val.goods_img" alt/>
                <div>
                  <p>{{ val.name }}</p>
                  <p>￥{{ val.price }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="all_classification_for_cen_right remen" v-if="item.two_class_index == 0">
            <ul>
              <!--              asdjhk -->
              <li v-for="(val,key) in item.two_class[item[`two_class_index`]].goods" :key="key"
                  @click="getxiangqing(val.id)">
                <img :src="$store.state.Url+val.goods_img" alt/>
                <div>
                  <p>{{ val.name }}</p>
                  <p>￥{{ val.price }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div
            class="all_classification_for_cen_right remen"
            v-if="remenindex == 1"
            @mouseenter="remen(1)"
          >
            <ul>
              <!--              asdjhk -->
              <li v-for="(val,key) in all.one_class[item[`two_class_index1`]].goods" :key="key"
                  @click="getxiangqing(val.id)">
                <img :src="$store.state.Url+val.original_img" alt/>
                <div>
                  <p>{{ val.name }}</p>
                  <p>￥{{ val.price }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div class="clear"></div>
        </div>
        <div class="all_classification_for_bottom">
          <!--      photo    广告图-->
          <img :src="$store.state.Url+item.photo" alt @click="getUrl(item.photo_url)"/>
        </div>
      </div>
      <!--    左边固定-->
      <div class="all_gu" v-if="searchBarFixed == true" :style="{'top':leftClass?leftClass:''}">
        <!-- <div class="all_gu_top">
           <img src="../assets/logoTop.gif" alt />
         </div>-->
        <div
          v-for="(item,key) in all.one_class"
          :class="uid===item.id?`all_gu_top_for current`:'all_gu_top_for'"
          :key="key"
          @click="anchorJump(item.id)"
        >{{ item.title }}
        </div>
        <div class="all_gu_top_for" @click="backTop">
          <img src="../assets/fanhuidingbu.png" alt/>
          顶部
        </div>
      </div>

    </div>
    <!--    真快好省-->
    <div class="all_zhenhao">
      <div class="all_zhenhao_cen">
        <div class="all_zhenhao_cen_for">
          <img src="../assets/service_items_1.jpg" alt/>
          <!--          真诚服务 值得信赖-->
        </div>
        <div class="all_zhenhao_cen_for">
          <img src="../assets/service_items_2.jpg" alt/>
          <!--          真诚服务 值得信赖-->
        </div>
        <div class="all_zhenhao_cen_for">
          <img src="../assets/service_items_3.jpg" alt/>
          <!--          真诚服务 值得信赖-->
        </div>
        <div class="all_zhenhao_cen_for">
          <img src="../assets/service_items_4.jpg" alt/>
          <!-- 真诚服务 值得信赖 -->
        </div>
      </div>
    </div>
    <!--    链接-->
    <div class="all_link">
      <div class="all_link_cen">
        <div class="all_link_cen_for" v-for="(item,key) in all.bottom" :key="key">
          <div>{{ item.name }}</div>
          <ul>
            <li v-for="(value,key) in item.bottom_two" @click="getCliak(value.url)">{{ value.name }}</li>
          </ul>
        </div>
      </div>
    </div>
    <!--    页脚-->
    <Pagetail></Pagetail>
    <!--    在线留言-->
    <div class="all_Leaving" v-if="Size == 1">
      <div class="all_Leaving_top">
        <div class="all_Leaving_top_left">请您留言</div>
        <div class="all_Leaving_top_right" @click="getSize(2)">-</div>
        <div class="clear"></div>
      </div>
      <div class="all_Leaving_cen">
        <p style="margin-top: -10px;">办公所需全友</p>
        <p style="margin-bottom: 10px;">400-700-2248</p>
      </div>
      <div class="all_Leaving_bottom">
        <textarea placeholder="请在此输入留言内容，我们会尽快与您联系。（必填）" v-model="form.content"></textarea>
        <div class="all_Leaving_bottom_input">
          <img src="../assets/xingming.png" alt/> 
          <input type="text" placeholder="姓名（必填）" v-model="form.name"/>
        </div>
        <div class="all_Leaving_bottom_input">
          <img src="../assets/dianhua.png" alt/>
          <input type="text" placeholder="电话（必填）" v-model="form.phone"/> 
        </div>
        <div class="all_Leaving_bottom_input">
          <img src="../assets/feilei.png" alt/>
          <input type="text" placeholder="公司名称" v-model="form.ness"/>
        </div>
        <button @click="sub">发 送</button>
      </div>
    </div>
    <div class="all_Leavinges" v-if="Size == 2">
      <div class="all_Leaving_top1">
        <div class="all_Leaving_top1_left">请您留言</div>
        <div class="all_Leaving_top1_right" @click="getSize(1)">
          <p></p>
        </div>
        <div class="clear"></div>
      </div>
    </div>
        <!--    右边固定-->
    <div class="all_gu_right">
      <div title="登录" class="all_gu_top_for" @click="$router.push({path:'/login/'})" v-if="$store.state.user.token==undefined || $store.state.user.token == ''">
        <img src="../assets/denglu.png" alt/>
      </div>
      <div title="客服" class="all_gu_top_for" @click="getSize(1)">
        <img src="../assets/kedu.png" alt/>
      </div>
      <div title="购物车" class="all_gu_top_for" @click="$router.push({path:'/ShoppingCart'})">
        <img src="../assets/shopgou.png" alt/>
      </div>
      <div title="推荐" class="all_gu_top_for" @click="$router.push({path:'/bannerShop'})">
        <img src="../assets/tuijian.png" alt/>
      </div>
      <div title="返回顶部" class="all_gu_top_for" @click="backTop">
        <img src="../assets/fanhuidingbu.png" alt/>
      </div>
    </div>
  </div>
</template>

<script>
import {getinit, getsub} from "../api/index";
import Pagetail from '../assembly/Pagetail'
import Head from '../assembly/Head'

export default {
  name: "HelloWorld",
  data() {
    return {
      swiperOption: {
        // some swiper options/callbacks
        // 所有的参数同 swiper 官方 api 参数
        // ...
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      },
      swiperOption1: {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        pagination: {
          // el: '.can',
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      StatusType: true,
      all: {
        top_img: '',
        left_img: '',
        right_img: '',
        one_class: '',
        photo: '',
        video: '',
        class_cation: [],
        class: [],
      },
      index: "",
      two_class_index: 0,
      two_class_index1: 0,
      //留言
      form: {
        name: "",
        phone: "",
        ness: "",
        user_id: "",
        content: ""
      },
      abc: [],
      searchBarFixed: false,
      Size: 2,
      remenindex: 2,
      datalist: {},
      leftClass: 0,
      uid:''
    };
  },
  components: {
    Pagetail, Head
  },
  mounted() {
    let obj = document.getElementById("test");
    // alert(obj.offsetWidth);
    // alert(window.screen.availWidth);
    /*let styleleft = (window.screen.availWidth - obj.offsetWidth) / 2
    this.leftClass = (styleleft - 110) + 'px'*/
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    getjiejue(id, key) {
      if (key == 0) {
        this.$router.push({path: '/jiejue'})
      } else {
        this.$router.push({path: '/tesegou', query: {id: id}})
      }
    },
    getCliak(url) {
      window.location.href = `${url}`
    },
    getUrl(url) {
      window.location.href = `${url}`
    },
    getPinpai(url) {
      window.location.href = `${url}`
    },
    getCLick(url) {
      // alert(1)
      window.location.href = `${url}`
    },
    getxiangqing(id) {
      this.$router.push({path: '/details', query: {id: id, status: 2}})
    },
    getList(id, e, name) {
      this.$router.push({path: '/ListOfCommodities/', query: {Yiji: id, id: e, shop: name}})
    },
    getList1(id, e, name) {
      this.$router.push({path: '/ListOfCommodities/', query: {Yiji: id, cat: e, shop: name}})
    },
    truncate(arr) {
      var m = [];
      for (var i = 0; i < arr.length - 1; i++) {
        if (i.id != 4) {
          m.push(arr[i]);
        }
      }
      return m;
    },
    init() {
      getinit().then(res => {
        this.all = res;
        this.all.one_class = this.truncate(this.all.one_class).map((v, i) => {
          //插入参数
          v.two_class.unshift({
            goods: v.goods,
            name: ""
          });
          return {...v, two_class_index: 0, two_class_index1: 0};
        });
      });
    },
    handleScroll(e) {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >1000) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
      this.leftClass = (scrollTop-1170) + 'px'
      if (scrollTop>1200&&scrollTop<1800){
        this.uid = this.all.one_class[0].id
      }else if (scrollTop>1800&&scrollTop<2400){
        this.uid = this.all.one_class[1].id
      }else if (scrollTop>2400&&scrollTop<3000){
        this.uid = this.all.one_class[2].id
      }else if (scrollTop>3000&&scrollTop<3600){
        this.uid = this.all.one_class[3].id
      }else if (scrollTop>3600&&scrollTop<4200){
        this.uid = this.all.one_class[4].id
      }else if (scrollTop>4200&&scrollTop<4800){
        this.uid = this.all.one_class[5].id
      }else if (scrollTop>4800&&scrollTop<5400){
        this.uid = this.all.one_class[6].id
      }else if (scrollTop>5400&&scrollTop<6000){
        this.uid = this.all.one_class[7].id
      }else if (scrollTop>6000&&scrollTop<6600){
        this.uid = this.all.one_class[8].id
      }else if (scrollTop>6600&&scrollTop<7000){
        this.uid = this.all.one_class[9].id
      }else if (scrollTop>7000){
        this.uid = this.all.one_class[10].id
      }
    },
    backTop() {
      window.scrollTo(0, 0);
      console.log(this.$store.state.user.token)
    },
    sub() {
      // console.log(JSON.parse(localStorage.getItem('user')).id)
      if (JSON.parse(localStorage.getItem('user'))) {
        getsub({
          name: this.form.name,
          phone: this.form.phone,
          ness: this.form.ness,
          user_id: JSON.parse(localStorage.getItem('user')).id,
          content: this.form.content
        }).then(res => {

        });
      } else {
        getsub({
          name: this.form.name,
          phone: this.form.phone,
          ness: this.form.ness,
          content: this.form.content
        }).then(res => {

        });
      }

    },
    anchorJump(id) {
      this.uid = id
      document.querySelector("#ss" + id).scrollIntoView(true);
    },
    getSize(type) {
      this.Size = type;
    },
    /*    remen(type){
      this.remenindex = type
    },
    remen1(type){
      this.remenindex = type
    }*/
  }
};
</script>
<style scoped lang="less">
@import "./css/index";

.all_classification {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}
.current{
  background: #ff4500;
  color     : white;
  cursor    : pointer;
}
</style>
<style>
.swiper-pagination-bullet{
  width: 15px;
  height: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue